import * as React from 'react'
import type { VerifiedEventBuyer } from '@/components/events/member-ticket-verification'

export function useMemberVerification(
  supplied: VerifiedEventBuyer | null | undefined,
  onVerified: ((verification: VerifiedEventBuyer) => void) | undefined,
) {
  const [local, setLocal] = React.useState<VerifiedEventBuyer | null>(null)
  return { memberVerification: supplied ?? local, handleMemberVerification: onVerified ?? setLocal }
}
